<template>
    <div>        
        <v-sheet class="px-6 pt-6">
            <div class="container">
                <div class="d-flex flex-wrap justify-space-between mb-8">
                    <h5 class="ma-3 mb-0 d-flex flex">{{ ( createMode ? "Create a New Adpoint" : "Edit Adpoint" ) }}</h5>                        
                    <div class="flex-1 text-right">
                        <v-btn class="ma-2" dark color="success" :loading="loading" @click="()=>{save()}">
                            <v-icon class="pr-2">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                        <v-btn v-if="!createMode" class="ma-2" dark color="success" :loading="loading" @click="()=>{save(true)}">
                            <v-icon class="pr-2">mdi-content-save</v-icon>
                            Save & Close
                        </v-btn>
                    </div>
                </div>
            </div>
        </v-sheet>
        <v-form  v-model="editFormValid" ref="editForm">
        <v-row justify="center">                 
            <v-col cols="10" md="5">
                <e-info-card
                    title="Primary Fields"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <div>
                            <v-list>
                                <v-list-item>
                                    <!-- <v-list-item-avatar>
                                        <img :src="''" alt="" />
                                    </v-list-item-avatar> -->                                                                                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Adpoint ID" 
                                            v-model="adpointid"
                                            outlined
                                            :readonly="!createMode"   
                                            :validate-on-blur="createMode"
                                            :rules="(createMode ? codeRules : [])"                                       
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>
                                    <!-- <v-list-item-avatar>
                                        <img :src="''" alt="" />
                                    </v-list-item-avatar> -->                                                                                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Title" 
                                            v-model="description"                                                                                                                                    
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="networkId"
                                            :items="networkOptions"                 
                                            label="Network"                                             
                                            :rules="requiredRules"
                                            :validate-on-blur="createMode"                                                 
                                            :clearable="true"      
                                            @input="onSchemeChanged"                
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="clusterId"
                                            :items="clusterOptions"                 
                                            label="Cluster"                                             
                                            :rules="requiredRules"
                                            :validate-on-blur="createMode"                                                 
                                            :clearable="true"                                                              
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>  
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="deviceId"
                                            :items="deviceTypeOptions"                 
                                            label="Placement Type"                                             
                                            :rules="requiredRules"
                                            :validate-on-blur="createMode"                                                 
                                            :clearable="true"  
                                            @input="onSchemeChanged"                    
                                        />
                                    </v-list-item-content>                                
                                </v-list-item> 
                                <!--<v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="brandId"
                                            :items="brandOptions"                                                
                                            label="Brand"                                                                                                                                      
                                            :clearable="false"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>-->
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="location"
                                            :items="locationOptions"                 
                                            label="Location"                                                                                                                                                    
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>  
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="environment"
                                            :items="environmentOptions"                 
                                            label="Environment"                                                                                                                                                    
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="operating_schedule"
                                            :items="operating_scheduleOptions"                 
                                            label="Operating Schedule"                                                                                                                                                    
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>     
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-checkbox
                                            v-model="debugmode"
                                            label="Debug Mode"          
                                        />                                        
                                    </v-list-item-content>                                
                                </v-list-item>     
                                <v-list-item v-if="fieldSchemeHasChanged"> 
                                    <v-list-item-content>
                                        <v-alert border="top" color="red lighten-2" dark>
                                            When either a new <strong>Network</strong> or <strong>Placement Type</strong> is selected, you have to hit the 'Save' button before continuing, so that the correct Attribute Fields will be displayed, based on your selection.
                                        </v-alert>
                                    </v-list-item-content>                        
                                </v-list-item>
                            </v-list>  
                        </div>                      
                    </template>
                </e-info-card>
            </v-col>

            <v-col cols="10" md="5" v-if="allLocations.find(l=>l.code == location)">
                <e-info-card
                    title="Location & Operating Hours Information"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <div>
                            <v-list>
                                <v-list-item>
                                    <pre>
                                        {{ displayLocationExtraInfo }}
                                    </pre>                                    
                                </v-list-item>                                
                            </v-list>  
                        </div>                      
                    </template>
                </e-info-card>
            </v-col>

            <v-col cols="10" md="5">
                <e-info-card
                    title="Behaviour"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <div>
                            <v-list>
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="status"
                                            :items="['Online','Offline','Disabled']"                 
                                            label="Status"                                             
                                            :rules="requiredRules"
                                            :validate-on-blur="createMode"                                                 
                                            :clearable="true"                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item> 
                                <!-- <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Default Daily Capacity Potential (Impressions)" 
                                            :rules="requiredRules"
                                            v-model.number="nominalCapacity"
                                            type="number"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>           -->
                                <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="No of Adpoints" 
                                            :rules="requiredRules"
                                            v-model.number="impression_factor"
                                            type="number"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>       
                                <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-checkbox
                                            label="Multiview"                                             
                                            v-model="multiview"                                            
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>               
                            </v-list>  
                        </div>                      
                    </template>
                </e-info-card>
            </v-col>

            <v-col cols="10" md="5">
                <e-info-card
                    title="General Attributes"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <div>
                            <v-list>     
                                <v-list-item v-for="attr in this.dynamicAttrs.generic" :key="attr.name">  
                                    <v-list-item-content class="pt-0">
                                        <AttributeEditField v-bind="attr" v-model="attr.value" />                                          
                                    </v-list-item-content>                                    
                                </v-list-item>
                            </v-list>  
                        </div>                      
                    </template>
                </e-info-card>
            </v-col>

            <v-col cols="10" md="5">
                <e-info-card
                    title="Technical Attributes"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <div>
                            <v-list> 
                                <v-list-item v-for="attr in this.dynamicAttrs.technical" :key="attr.name">  
                                    <v-list-item-content class="pt-0">
                                        <AttributeEditField v-bind="attr" v-model="attr.value" />                                                                                   
                                    </v-list-item-content>
                                </v-list-item>                                                    
                            </v-list>  
                        </div>                      
                    </template>
                </e-info-card>
            </v-col>

            <v-col cols="10" md="5">
                <e-info-card
                    title="Targeting Attributes"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <div>
                            <v-list> 
                                <v-list-item v-for="attr in this.dynamicAttrs.targeting" :key="attr.name">  
                                    <v-list-item-content class="pt-0">
                                        <AttributeEditField v-bind="attr" v-model="attr.value" />                                                                                   
                                    </v-list-item-content>
                                </v-list-item>                                                    
                            </v-list>  
                        </div>                      
                    </template>
                </e-info-card>
            </v-col>

            <v-col cols="10" md="5">
                <e-info-card
                    title="Geographical Attributes"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <div>
                            <v-list> 
                                <v-list-item v-for="attr in this.dynamicAttrs.positional" :key="attr.name">  
                                    <v-list-item-content class="pt-0">
                                        <AttributeEditField v-bind="attr" v-model="attr.value" />                                                                                   
                                    </v-list-item-content>
                                </v-list-item>                                                    
                            </v-list>  
                        </div>                      
                    </template>
                </e-info-card>
            </v-col>

            <v-col cols="10" md="5">
                <e-info-card
                    title="Product Categorization Attributes"
                    sub-title=""
                >
                    <template slot="basic-info-slot">     
                        <div>
                            <v-list>  
                                <v-list-item v-for="attr in this.dynamicAttrs.productcategory" :key="attr.name">
                                    <v-list-item-content class="pt-0">
                                        <AttributeEditField v-bind="attr" v-model="attr.value" />                                          
                                    </v-list-item-content>                                      
                                </v-list-item>                                                   
                            </v-list>  
                        </div>                      
                    </template>
                </e-info-card>
            </v-col>

            <v-col cols="10" md="8">
                <e-info-card
                    class="mt-4"
                    title="Target Audiences"
                    sub-title=""
                >
                    <template slot="basic-info-slot">
                        <v-alert v-if="audienceError" type="error">
                            {{ audienceError }}
                        </v-alert>
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th>Audience</th>
                                    <th>Rationale</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(audience, index) in targetAudiences" :key="'adp-aud-' + index">
                                    <td style="width: 500px;">
                                        <v-select
                                            :items="audienceOptions"
                                            v-model="audience.audience_code"
                                            item-text="text"
                                            item-value="value"
                                            label="Audience"
                                            dense
                                            hide-details
                                            clearable
                                            :disabled="audienceOptions.length === 0"
                                        />
                                    </td>
                                    <td>
                                        <v-text-field
                                            label="Rationale"
                                            v-model="audience.rationale"
                                            hide-details
                                        />
                                    </td>
                                    <td class="text-right">
                                        <v-btn icon small @click="removeAudienceRow(index)">
                                            <v-icon small>mdi-trash-can-outline</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                                <tr v-if="targetAudiences.length === 0">
                                    <td colspan="3" class="text-center text--disabled py-4">
                                        No audiences selected yet.
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <v-btn class="mt-4" small color="primary" @click="addAudienceRow" :disabled="audienceOptions.length === 0">
                            <v-icon left small>mdi-plus</v-icon>
                            Add Audience
                        </v-btn>
                    </template>
                </e-info-card>
            </v-col>

            <v-col cols="10" md="8">
                <e-info-card
                    class="mt-4"
                    title="Cluster Audiences (Preview)"
                    sub-title=""
                >
                    <template slot="basic-info-slot">
                        <v-alert v-if="clusterAudiencesPreviewLoading" type="info" border="left" dense>
                            Loading cluster audiences...
                        </v-alert>
                        <v-simple-table v-if="!clusterAudiencesPreviewLoading">
                            <thead>
                                <tr>
                                    <th>Audience</th>
                                    <th>Rationale</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(audience, index) in clusterAudiencesPreview" :key="'cluster-aud-' + index">
                                    <td style="width: 500px;">
                                        {{ formatAudienceLabel(audience) }}
                                    </td>
                                    <td>
                                        {{ audience.rationale || '-' }}
                                    </td>
                                </tr>
                                <tr v-if="clusterAudiencesPreview.length === 0">
                                    <td colspan="2" class="text-center text--disabled py-4">
                                        No audiences assigned to the selected cluster.
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </template>
                </e-info-card>
            </v-col>


            
        </v-row>
        </v-form>
        <!-- <base-card class="transparent">
            
        </base-card> -->
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            bottom
            tile
            :color="snackbarColor + ' -accent-2'"            
            >
            {{ snackbarMessage }}
        </v-snackbar>
    </div>
</template>
<script>
import avatarGroupCard from '@/components/card/AvatarGroupCard';
import EInfoCard from '@/components/card/BasicInfoCard';
import {api} from "src/api/index";
import { fieldNotEmpty, fieldMinLength } from "src/core/vuetify-validators.js";
import AttributeEditField from '@/components/core/AttributeEditField';

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Adpoint Edit'
    },
    components: {
        avatarGroupCard,
        EInfoCard,
        AttributeEditField
    },
    data() {
        return {
            //primary data
            adpointid: '',
            description: '',
            networkId: '',
            clusterId: '',
            deviceId: '',
            brandId: '',
            location: '',
            locationAndOperInfo: null,
            environment: '',
            operating_schedule: null,
            debugmode: false,
            multiview: false,
            status: '',
            nominalCapacity: '',
            impression_factor: 1,
            dynamicAttrs: {},
            targetAudiences: [],
            audienceOptions: [],
            audienceError: '',
            clusterAudiencesPreview: [],
            clusterAudiencesPreviewLoading: false,

            fieldSchemeHasChanged: false,


            type: '',
            crud_code: '',
            disabled: false,
            //ui mechanics      
            createMode: false,                  
            invitationFormValid: true,
            editFormValid: true,            
            //error
            loading: false,
            snackbar: false,
            snackbarColor: 'green',
            snackbarMessage: '',
            error: '',
            //reference data    
            networkOptions: [],
            clusterOptions: [],
            deviceTypeOptions: [],
            brandOptions: [],
            environmentOptions: [{value: 'ADDREALITY', text: 'DisplayForce'},{value: 'PRODME', text: 'Product.me'},{value: 'OTHER', text: 'Other'}],
            operating_scheduleOptions: [{value:  null, text: 'Location'}, {value: '24hour7days',  text: 'Always On (24/7)'}],
            locationOptions: [],
            allLocations: [],
            requiredRules: [
                fieldNotEmpty                
            ],
            codeRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)  
            ],
            treeitems: [
        {
          id: 5,
          name: 'Country :',
          children: [
            {
              id: 6,
              name: 'Area :',
              children: [
                {
                  id: 7,
                  name: 'Store :',
                  children: [
                    { id: 8, name: 'Floor :' },
                    { id: 9, name: 'Section :' },
                  ],
                },
              ],
            }           
          ],
        },       
      ]
        }
    },
    computed: {
        status() {
            return (this.disabled) ? "Disabled" :
                    (this.invitation_code) ? "Invited" :
                    (this.activation_date === "" || this.activation_date == null) ? "Awaiting Activation" : "Active";                    
        },
        displayLocationExtraInfo() {
            const loc = this.allLocations.find(l => l.code === this.location);
            if(!loc || !loc.extra_info) {
                return 'No Extra Info';
            }
            const { nearby_places_data, ...rest } = loc.extra_info;
            return JSON.stringify(rest, null, 6);
        }
    },
    watch: {
        clusterId(value) {
            this.fetchClusterAudiences(value);
        }
    },
    async created() {
        if(this.$route.params.code) {
            this.crud_code = this.$route.params.code;       
            this.createMode = false;     
        }
        else {            
            this.createMode = true;
        }

        let rsp = {}
        if(!this.createMode) {
            rsp = await api.adpoint.getInitEditData(this.crud_code);
        }
        else {
            rsp = await api.adpoint.getInitEditData();
        }
        this.initEditForm(rsp);
    },
    async mounted() {      
        // if(!this.createMode) {
        //     const rspB = await api.network.getOne(this.crud_code);
        //     if(rspB && rspB.data) {
        //         this.code = rspB.data.code;
        //         this.title = rspB.data.title;
        //         this.description = rspB.data.description;
        //         this.type = rspB.data.type;            
        //     }
        //     //this.editFormValid = true;  
        // }      
    },
    methods: {
        initEditForm(rsp) {
            this.networkOptions = rsp.data.init.networkOptions;
            this.clusterOptions = rsp.data.init.clusterOptions;
            this.deviceTypeOptions = rsp.data.init.deviceTypeOptions;
            this.brandOptions = rsp.data.init.brandOptions;  
            this.locationOptions = rsp.data.init.locationOptions
            this.allLocations = rsp.data.init.allLocations;
            this.audienceOptions = (rsp.data.init.audienceOptions || []).map(d=> ({...d, value: d.value != null ? d.value.toString() : d.value}));
            this.reloadFormData(rsp.data.edit);
        },
        reloadFormData(editData) {
            editData = editData || {};
            this.adpointid = editData.adpointid;
            this.description = editData.description;
            this.networkId = editData.networkId;
            this.clusterId = editData.clusterId;
            this.deviceId = editData.deviceId;
            this.brandId = editData.brandId || 4;
            this.location = editData.location;
            this.status = editData.status || 'Online';
            this.environment = editData.environment;
            this.operating_schedule = editData.operating_schedule;
            this.debugmode = editData.debugmode;
            this.multiview = !!editData.multiview;
            this.nominalCapacity = editData.nominalCapacity || 2880;
            this.impression_factor = editData.impression_factor || 1;        
            this.dynamicAttrs = this._convertAttrsToArray(editData.attributes || {});
            const audiences = Array.isArray(editData.audiences) ? editData.audiences : [];
            this.targetAudiences = audiences.map(a => ({
                audience_code: a.audience_code || (a.audience ? a.audience.code : null),
                rationale: a.rationale || ''
            }));
            if(this.$refs.editForm) {
                this.$refs.editForm.resetValidation();
            }
            this.fieldSchemeHasChanged = false;
        },
        onSchemeChanged() {
            this.fieldSchemeHasChanged = true;
        },
        addAudienceRow() {
            this.targetAudiences.push({
                audience_code: null,
                rationale: ''
            });
        },
        removeAudienceRow(index) {
            this.targetAudiences.splice(index, 1);
        },
        validateAudienceSelections() {
            this.audienceError = '';
            if(this.targetAudiences.length === 0) {
                return true;
            }
            if(this.targetAudiences.some(entry => !entry.audience_code)) {
                this.audienceError = "Please select an audience for every row.";
                return false;
            }
            const codes = this.targetAudiences.map(entry => entry.audience_code);
            if((new Set(codes)).size !== codes.length) {
                this.audienceError = "Duplicate audiences are not allowed.";
                return false;
            }
            return true;
        },
        buildAudiencePayload() {
            return this.targetAudiences
                .filter(entry => entry && entry.audience_code)
                .map(entry => ({
                    audience_code: entry.audience_code,
                    rationale: entry.rationale || ''
                }));
        },
        async fetchClusterAudiences(clusterId) {
            if(!clusterId) {
                this.clusterAudiencesPreview = [];
                this.clusterAudiencesPreviewLoading = false;
                return;
            }
            this.clusterAudiencesPreviewLoading = true;
            try {
                const rsp = await api.cluster.getOne(clusterId);
                this.clusterAudiencesPreview = (rsp.data?.audiences || []).map(a => ({
                    audience_code: a.audience_code || (a.audience ? a.audience.code : null),
                    audience: a.audience || null,
                    rationale: a.rationale || ''
                }));
            } catch (error) {
                this.clusterAudiencesPreview = [];
            } finally {
                this.clusterAudiencesPreviewLoading = false;
            }
        },
        formatAudienceLabel(audienceEntry) {
            if(!audienceEntry) {
                return '-';
            }
            const aud = audienceEntry.audience;
            return (aud && (aud.condensed_name || aud.code)) || audienceEntry.audience_code || '-';
        },
        save(close=false) {
            console.log(JSON.stringify(this.dynamicAttrs.generic, null, 2));
            this.error = '';     
            this.$refs.editForm.validate();                          
            if(!this.editFormValid) {                
                this.snackbarColor = "red";
                this.snackbarMessage = "There are invalid fields.";
                this.snackbar = true;
                return;
            }
            if(!this.validateAudienceSelections()) {
                this.snackbarColor = "red";
                this.snackbarMessage = this.audienceError;
                this.snackbar = true;
                return;
            }
            this.loading = true;
            if(this.createMode) {
                api.adpoint.create(
                    {   
                        adpointid: this.adpointid,
                        description: this.description,
                        networkId: this.networkId,
                        clusterId: this.clusterId,
                        deviceId: this.deviceId,
                        brandId: this.brandId,
                        location: this.location,
                        nominalCapacity: this.nominalCapacity,
                        status: this.status,
                        environment: this.environment,
                        operating_schedule: this.operating_schedule,
                        debugmode: this.debugmode,
                        multiview: this.multiview,
                        impression_factor: this.impression_factor,                        
                        attributes: this._convertArrayToAttrs(this.dynamicAttrs),
                        audiences: this.buildAudiencePayload()
                    }                    
                )
                .then((rsp)=>{               
                    //this.$router.push("/mng/system/users/edit/" + rsp.data.code);  
                    //this.$router.push({ name: "system-users-edit", params: {code: rsp.data.code}});
                    // this.snackbarColor = "green";
                    // this.snackbarMessage = "User updated successfully";
                    // this.snackbar = true;  
                    this.crud_code = rsp.data.id;        
                    this.createMode = false;
                    this.reloadFormData(rsp.data);
                    this.$router.replace("/mng/adpoints/management/edit/" + rsp.data.id);                    
                })
                .catch((error)=>{
                    //this.error = error.response.data.message;
                    this.snackbarColor = "red";
                    this.snackbarMessage = error.response.data.message;
                    this.snackbar = true;
                })
                .finally(()=>{
                    this.loading = false;
                })
            }
            else { //edit mode
                api.adpoint.update(this.crud_code, 
                    {   
                        adpointid: this.adpointid,
                        description: this.description,
                        networkId: this.networkId,
                        clusterId: this.clusterId,
                        deviceId: this.deviceId,
                        brandId: this.brandId,
                        location: this.location,
                        nominalCapacity: this.nominalCapacity,
                        status: this.status,
                        environment: this.environment,
                        operating_schedule: this.operating_schedule,
                        debugmode: this.debugmode,
                        multiview: this.multiview,
                        impression_factor: this.impression_factor,                        
                        attributes: this._convertArrayToAttrs(this.dynamicAttrs),
                        audiences: this.buildAudiencePayload()
                    }
                )
                .then(async (rsp)=>{               
                    //this.$router.push("/mng/system/users/edit/" + rsp.data.code);  
                    //this.$router.push({ name: "system-users-edit", params: {code: rsp.data.code}});                                                 
                    if(close) {
                        this.$router.back();
                    }
                    else {
                        this.snackbarColor = "green";
                        this.snackbarMessage = "Adpoint saved successfully";
                        this.snackbar = true;             
                        this.reloadFormData(rsp.data);
                    }

                    //this.$router.push("/mng/adpoints/management/edit/" + rsp.data.id);
                    // this.$router.push("/mng/adpoints/management/edit");
                })
                .catch((error)=>{
                    //this.error = error.response.data.message;
                    this.snackbarColor = "red";
                    this.snackbarMessage = error.response.data.message;
                    this.snackbar = true;
                })
                .finally(()=>{
                    this.loading = false;
                })
            }                
        },          
        _convertAttrsToArray(src) {
            const rslt = Object.values(src).reduce((rslt, arrayItem) => {
                if(!arrayItem.hierarchy) {
                    if(!rslt['generic']) rslt['generic'] = [];
                    rslt['generic'].push(arrayItem);
                }
                else {
                    if(!rslt[arrayItem.hierarchy]) rslt[arrayItem.hierarchy] = [];
                    rslt[arrayItem.hierarchy].push(arrayItem);
                }
                return rslt;
            }, {});
            let orderedRslt = {};
            for(const group in rslt){
                orderedRslt[group] = rslt[group].sort((a,b)=>{
                    if(a.name < b.name) return -1;
                    if(a.name > b.name) return 1;
                    return 0;
                })
            }
            return orderedRslt;
        },
        _convertArrayToAttrs(src) {
            let rslt = {};
            for(const srcProp in src) {
                for(const attr of src[srcProp]) {
                    rslt[attr.name] = attr;
                }
            }            
            return rslt;
        },    
    }
}
</script>
<style lang="scss">
.ul-widget-profile-img {
    position: relative;
}
.ul-widget-profile-img:after {
    // content: "";
    // position: absolute;
    // top: 44px;
    // left: 50%;
    // width: 1px;
    // height: calc(100% - 30px);
    // background: #B3C0CE;
    content: '';
    position: absolute;
    top: 44px;
    left: 50%;
    width: 1px;
    height: calc(100% - 30px);
    background: #b3c0ce;
}
</style>
